export default "__VITE_ASSET__DEQZLziZ__"